import { themeLabel } from "@/lib/api";

export function AgeBadge({ rating, testid }) {
  const adult = rating === "adult";
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-display font-semibold text-white"
      style={{ background: adult ? "var(--yarn-adult)" : "var(--yarn-teen)" }}
    >
      {adult ? "18+" : "Underage"}
    </span>
  );
}

export function ThemeBadge({ theme, testid }) {
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center rounded-full border-2 border-[var(--yarn-stitch)] bg-[var(--yarn-linen)] px-2.5 py-0.5 text-xs font-display"
    >
      {themeLabel(theme)}
    </span>
  );
}
